import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/back-button.svg'
import _imports_1 from '@/assets/images/edit-button.svg'
import _imports_2 from '@/assets/images/warning.svg'
import _imports_3 from '@/assets/images/android.svg'
import _imports_4 from '@/assets/images/ios.svg'
import _imports_5 from '@/assets/images/piggy-bank.svg'
import _imports_6 from '@/assets/images/live-content-img.svg'


const _withScopeId = n => (_pushScopeId("data-v-4727b287"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "p-d-flex ended-border"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "decoration" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ended" }, "This Campaign has ended.", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "p-d-flex p-flex-wrap p-jc-center box-jc" }
const _hoisted_8 = { class: "p-ai-start campaign-name" }
const _hoisted_9 = { class: "p-d-flex p-flex-wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"margin-right":"4px"}
}, null, -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_13 = {
  key: 2,
  class: "p-mb-6"
}
const _hoisted_14 = { class: "p-d-inline-flex" }
const _hoisted_15 = {
  key: 3,
  class: "p-d-flex p-mb-6"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"5px","width":"15px","height":"15px"},
  src: _imports_2
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-end abscissa-axis" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ordinate-axis" })
], -1))
const _hoisted_18 = {
  class: "p-d-flex p-jc-between",
  style: {"margin-top":"27px"}
}
const _hoisted_19 = { style: {"margin-left":"20px"} }
const _hoisted_20 = { class: "campaign-date" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "campaign-text" }, "Campaign Start", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "campaign-date"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "campaign-text" }, "Campaign Progress", -1))
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "campaign-date" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "campaign-text" }, "Campaign Finish", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border p-mt-6" }, null, -1))
const _hoisted_29 = { class: "p-d-flex p-flex-wrap gap" }
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "p-d-flex budget-border" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "budget-text" }, "Campaign Budget", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "edit-budget-icon",
  src: _imports_1
}, null, -1))
const _hoisted_34 = {
  class: "p-d-flex p-ml-4",
  style: {"padding-bottom":"40px","border-bottom":"1px solid rgba(0, 0, 0, 0.1)"}
}
const _hoisted_35 = { class: "p-d-flex p-flex-column" }
const _hoisted_36 = { class: "resources-left p-d-flex" }
const _hoisted_37 = { class: "currency" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resources" }, "Resources Left", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slash" }, "/", -1))
const _hoisted_40 = { class: "p-d-flex p-flex-column" }
const _hoisted_41 = { class: "p-d-flex" }
const _hoisted_42 = { class: "total-budget p-d-flex" }
const _hoisted_43 = { class: "currency" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resources" }, "Total Budget", -1))
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  class: "p-d-flex",
  style: {"margin-top":"40px"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-amount-c" }, "Campaign CPC:")
], -1))
const _hoisted_48 = { style: {"font-weight":"800","margin-left":"10px","margin-top":"5px"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "textbox" }, [
  /*#__PURE__*/_createTextVNode(" Need to make some changes? Edit CPCs throught the campaign to tweak performance. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Or increase your budget to continue seeing great results. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" You need to deposit the increased budget via Mangopay before the budget increase takes effect. ")
], -1))
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  class: "p-d-flex",
  style: {"margin-top":"40px"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-amount-c" }, "Campaign CPM:")
], -1))
const _hoisted_53 = { style: {"font-weight":"800","margin-left":"10px","margin-top":"5px"} }
const _hoisted_54 = { class: "p-d-flex" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-amount-c" }, "Payout Cap:")
], -1))
const _hoisted_56 = { style: {"font-weight":"800","margin-left":"10px","margin-top":"5px"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "textbox" }, [
  /*#__PURE__*/_createTextVNode(" Need to make some changes? Edit CPMs throught the campaign to tweak performance. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Or increase your budget to continue seeing great results. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" You need to deposit the increased budget via Mangopay before the budget increase takes effect. ")
], -1))
const _hoisted_58 = { key: 2 }
const _hoisted_59 = {
  class: "p-d-flex",
  style: {"margin-top":"40px"}
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600"} }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      class: "img"
    }),
    /*#__PURE__*/_createTextVNode("Android CPI :")
  ])
], -1))
const _hoisted_61 = { style: {"font-weight":"800","margin-left":"10px","margin-top":"5px"} }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600"} }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      class: "img"
    }),
    /*#__PURE__*/_createTextVNode("iOS CPI :")
  ])
], -1))
const _hoisted_63 = { style: {"font-weight":"800","margin-left":"10px","margin-top":"5px"} }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "textbox" }, [
  /*#__PURE__*/_createTextVNode(" Need to make some changes? Edit CPIs throught the campaign to tweak performance. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Or increase your budget to continue seeing great results. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" You need to deposit the increased budget via Mangopay before the budget increase takes effect. ")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "piggy-bank-image",
    src: _imports_5
  })
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "live-content-img",
    src: _imports_6
  }),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"100px","margin-left":"50px"} }, [
    /*#__PURE__*/_createElementVNode("div", { class: "checkout" }, "Checkout your best performing ads.")
  ])
], -1))
const _hoisted_67 = {
  class: "p-d-flex p-flex-wrap p-ml-6",
  style: {"margin-top":"100px"}
}
const _hoisted_68 = { class: "p-d-flex p-justify-between p-grid p-col-10 p-m-auto tab-preview" }
const _hoisted_69 = { class: "campaign-sub-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_campaign = _resolveComponent("create-campaign")!
  const _component_Terms = _resolveComponent("Terms")!
  const _component_Button = _resolveComponent("Button")!
  const _component_campaign_success_modal = _resolveComponent("campaign-success-modal")!
  const _component_pay_and_finish_modal = _resolveComponent("pay-and-finish-modal")!
  const _component_warning_modal = _resolveComponent("warning-modal")!
  const _component_ask_hint = _resolveComponent("ask-hint")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_campaigns_list_counters_new = _resolveComponent("campaigns-list-counters-new")!
  const _component_tracking_link_input = _resolveComponent("tracking-link-input")!
  const _component_campaign_closed_card = _resolveComponent("campaign-closed-card")!
  const _component_budget_modal = _resolveComponent("budget-modal")!
  const _component_payment_information_status = _resolveComponent("payment-information-status")!
  const _component_payment_information_modal = _resolveComponent("payment-information-modal")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_content_list = _resolveComponent("content-list")!
  const _component_campaigns_performance = _resolveComponent("campaigns-performance")!
  const _component_short_campaign_page = _resolveComponent("short-campaign-page")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, { style: {"max-width":"100%"} }, {
    default: _withCtx(() => [
      (_ctx.editCampaign)
        ? (_openBlock(), _createBlock(_component_create_campaign, {
            key: 0,
            campaign: _ctx.campaign,
            onSaveEdit: _ctx.saveEdit
          }, null, 8, ["campaign", "onSaveEdit"]))
        : _createCommentVNode("", true),
      (_ctx.isLoggedUserCampaignOwner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "back_button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
            }, [
              _hoisted_2,
              _createTextVNode(" Back to Campaign Management")
            ]),
            (_ctx.campaignClosed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.campaign?.name), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  label: "Terms And Conditions",
                  class: "term-and-conditions",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTerms = true))
                }, "Terms And Conditions"),
                _createVNode(_component_Terms, {
                  "show-modal": _ctx.showTerms,
                  onCloseTerms: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTerms = false))
                }, null, 8, ["show-modal"]),
                ((!_ctx.campaignClosed && _ctx.campaign?.status === 'draft') || _ctx.campaign?.status === 'pending')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "edit-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editCampaign = true))
                    }, [
                      _hoisted_10,
                      _createTextVNode("Edit Campaign ")
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.campaignClosed && _ctx.campaign?.status === 'active')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      label: "Close Campaign",
                      class: "continue-button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showWarningModal = true))
                    }, "Close Campaign"))
                  : _createCommentVNode("", true),
                (_ctx.campaign?.status === 'draft')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      label: "activate campaign",
                      disabled: _ctx.createLoading,
                      loading: _ctx.createLoading,
                      onClick: _ctx.launchCampaign,
                      class: "continue-button"
                    }, null, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.campaign?.status === 'pending')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 3,
                      label: "pending PayIn...",
                      disabled: "",
                      class: "continue-button"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_campaign_success_modal, {
                  "campaign-name": _ctx.campaign?.name,
                  "is-showing": _ctx.showSuccessModal,
                  "onUpdate:isShowing": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showSuccessModal) = $event)),
                  onCampaignLaunch: _ctx.goToNewCampaign
                }, null, 8, ["campaign-name", "is-showing", "onCampaignLaunch"]),
                _createVNode(_component_pay_and_finish_modal, {
                  "first-pay-campaign": false,
                  "new-data-budget": _ctx.newBudget,
                  onCancelPay: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPaymentModalActive = false)),
                  "view-modal": _ctx.showPaymentModalActive,
                  "campaign-id": _ctx.campaign?.id,
                  onCampaignPaySuccess: _ctx.campaignPaySuccess,
                  "create-file-csv": true
                }, null, 8, ["new-data-budget", "view-modal", "campaign-id", "onCampaignPaySuccess"]),
                _createVNode(_component_warning_modal, {
                  onCampaignClosed: _ctx.campaignClosing,
                  show: _ctx.showWarningModal,
                  "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showWarningModal) = $event))
                }, null, 8, ["onCampaignClosed", "show"])
              ])
            ]),
            (_ctx.campaign?.status === 'pending')
              ? (_openBlock(), _createElementBlock("h4", _hoisted_11, " As soon as funds will be credited to campaign's account, this campaign will be launched automatically and it will get the status 'Active\". "))
              : _createCommentVNode("", true),
            _hoisted_12,
            (!_ctx.campaignClosed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_Button, {
                    class: _normalizeClass([[_ctx.active === 0 ? 'red-board' : ''], "tabs"]),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.active = 0)),
                    label: "Campaign Stats"
                  }, null, 8, ["class"]),
                  _createVNode(_component_Button, {
                    class: _normalizeClass([[_ctx.active === 1 ? 'red-board' : ''], "tabs"]),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.active = 1)),
                    label: "Live Content "
                  }, null, 8, ["class"]),
                  false
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: _normalizeClass([[_ctx.active === 2 ? 'red-board' : ''], "tabs"]),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.active = 2)),
                        label: "Campaign Performance"
                      }, null, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Button, {
                    class: _normalizeClass([[_ctx.active === 3 ? 'red-board' : ''], "tabs"]),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.active = 3)),
                    label: "Campaign Preview"
                  }, null, 8, ["class"]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ask_hint, {
                      "tooltip-text": 'Once you campaign is live, all creators are free to browse and join your campaign at their own leisure',
                      class: "hint"
                    }),
                    (_ctx.campaign?.status === 'active')
                      ? (_openBlock(), _createBlock(_component_Dropdown, {
                          key: 0,
                          modelValue: _ctx.selectedInviteQuery,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedInviteQuery) = $event)),
                          options: [
              { name: 'Invite Creators on GameInfluencer.IO.', value: 'on' },
              { name: 'Invite Creators outside GameInfluencer.IO.', value: 'outside' },
            ],
                          onChange: _ctx.inviteCreators,
                          optionLabel: "name",
                          placeholder: "invite Creators",
                          class: "invite-button"
                        }, null, 8, ["modelValue", "options", "onChange"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.campaignClosed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", {
                    style: {"cursor":"pointer"},
                    class: _normalizeClass([[_ctx.active === 0 ? 'red-board' : ''], "tabs"]),
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.active = 0))
                  }, "Campaign Stats", 2),
                  _createElementVNode("div", {
                    style: {"cursor":"pointer"},
                    class: _normalizeClass([[_ctx.active === 1 ? 'red-board' : ''], "tabs"]),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.active = 1))
                  }, [
                    _createTextVNode(" Live Content "),
                    _hoisted_16
                  ], 2),
                  _createElementVNode("div", {
                    style: {"cursor":"pointer"},
                    class: _normalizeClass([[_ctx.active === 3 ? 'red-board' : ''], "tabs"]),
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.active = 3))
                  }, "Campaign Preview", 2)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TabView, {
              activeIndex: _ctx.active,
              "onUpdate:activeIndex": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.active) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TabPanel, { header: "Header I" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campaigns_list_counters_new, {
                      counters: {
              views: _ctx.totalCampaignsViews,
              clicks: _ctx.getGlobalCampaignByRegion(_ctx.campaign)?.clicks,
              android: _ctx.getGlobalCampaignByRegion(_ctx.campaign)?.android,
              ios: _ctx.getGlobalCampaignByRegion(_ctx.campaign)?.IOS,
            }
                    }, null, 8, ["counters"]),
                    _createElementVNode("div", {
                      class: "border-campaign",
                      style: _normalizeStyle([{"max-width":"70vw","min-width":"15%"}, { width: _ctx.differenceout + '%' }])
                    }, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.formatDate(_ctx.campaign?.dates?.startDate)), 1),
                          _hoisted_21
                        ]),
                        (!_ctx.campaignFinished)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              (!_ctx.campaignFinished)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(Math.round(_ctx.remDays, 1)) + " days left", 1))
                                : _createCommentVNode("", true),
                              _hoisted_24
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.campaignFinished)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.formatDate(_ctx.campaign?.dates?.endDate) || "-"), 1),
                              _hoisted_27
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 4),
                    _createVNode(_component_tracking_link_input, { campaign: _ctx.currentCampaign }, null, 8, ["campaign"]),
                    (_ctx.contentItems && _ctx.contentItems.length)
                      ? (_openBlock(), _createBlock(_component_campaign_closed_card, {
                          key: 0,
                          onCloseCard: _ctx.closeCard,
                          items: _ctx.contentItems,
                          "is-card-show": _ctx.cardShow,
                          "onUpdate:isCardShow": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.cardShow) = $event))
                        }, null, 8, ["onCloseCard", "items", "is-card-show"]))
                      : _createCommentVNode("", true),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", {
                            class: "edit-budget",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showBudgetModal = true))
                          }, [
                            _hoisted_33,
                            _createTextVNode(" Edit Budget ")
                          ]),
                          (_ctx.campaign)
                            ? (_openBlock(), _createBlock(_component_budget_modal, {
                                key: 0,
                                campaign: _ctx.campaign,
                                show: _ctx.showBudgetModal,
                                "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showBudgetModal) = $event)),
                                onBudgetModal: _ctx.budgetModal
                              }, null, 8, ["campaign", "show", "onBudgetModal"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_pay_and_finish_modal, {
                            "first-pay-campaign": true,
                            "new-data-budget": {
                    budget: _ctx.campaign?.budget,
                    cpi: _ctx.campaign?.cpi,
                  },
                            "view-modal": _ctx.showPaymentModal,
                            "campaign-id": _ctx.campaign?.id,
                            onCampaignPaySuccess: _ctx.campaignPaySuccess
                          }, null, 8, ["new-data-budget", "view-modal", "campaign-id", "onCampaignPaySuccess"])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createTextVNode(_toDisplayString(_ctx.campaign?.budget?.amount - _ctx.campaign?.budget?.amountLeft) + " ", 1),
                                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.campaign?.budget?.currency), 1)
                              ]),
                              _hoisted_38
                            ]),
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createTextVNode(_toDisplayString(_ctx.campaign?.budget?.amount) + " ", 1),
                                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.campaign?.budget?.currency), 1)
                                ])
                              ]),
                              _hoisted_44
                            ])
                          ]),
                          (_ctx.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.campaign?.cpc?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1)
                                ]),
                                _hoisted_49
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPM)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _hoisted_52,
                                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.campaign?.cpm?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1)
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _hoisted_55,
                                  _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.campaign?.cpm?.payoutCap) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1)
                                ]),
                                _hoisted_57
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, [
                                  _hoisted_60,
                                  _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.campaign?.cpi?.android?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1),
                                  _hoisted_62,
                                  _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.campaign?.cpi?.ios?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1)
                                ]),
                                _hoisted_64
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _hoisted_65
                    ]),
                    _createVNode(_component_payment_information_status, {
                      validated: 
              !!(
                _ctx.campaign?.paymentInformation?.PersonType &&
                _ctx.campaign?.paymentInformation?.FirstName &&
                _ctx.campaign?.paymentInformation?.LastName &&
                _ctx.campaign?.paymentInformation?.Nationality &&
                _ctx.campaign?.paymentInformation?.CountryOfResidence
              )
            ,
                      onChangeInfo: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showPayment = true)),
                      onAddInfo: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showPayment = true))
                    }, null, 8, ["validated"]),
                    (_ctx.showPayment)
                      ? (_openBlock(), _createBlock(_component_payment_information_modal, {
                          key: 1,
                          "campaign-id": _ctx.campaign?.id,
                          "show-modal": _ctx.showPayment,
                          onPaymentInfoChange: _ctx.paymentInfoChange
                        }, null, 8, ["campaign-id", "show-modal", "onPaymentInfoChange"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_TabPanel, { header: "Header II" }, {
                  default: _withCtx(() => [
                    _hoisted_66,
                    _createElementVNode("div", _hoisted_67, [
                      (_ctx.contentItems && _ctx.contentItems.length > 0)
                        ? (_openBlock(), _createBlock(_component_content_list, {
                            key: 0,
                            items: _ctx.contentItems,
                            onRequestSuccess: _ctx.requestSuccess,
                            "campaign-closed": _ctx.campaignClosed,
                            campaign: _ctx.campaign
                          }, null, 8, ["items", "onRequestSuccess", "campaign-closed", "campaign"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_TabPanel, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_campaigns_performance)
                  ]),
                  _: 1
                }),
                _createVNode(_component_TabPanel, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.campaign?.name), 1),
                      _createElementVNode("div", {
                        label: "Terms And Conditions",
                        class: "term-and-conditions",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showTerms = true))
                      }, "Terms And Conditions"),
                      _createVNode(_component_Terms, {
                        "show-modal": _ctx.showTerms,
                        "onUpdate:showModal": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showTerms) = $event)),
                        onCloseTerms: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showTerms = false))
                      }, null, 8, ["show-modal"])
                    ]),
                    _createVNode(_component_short_campaign_page, {
                      onUpdateCampaign: _ctx.updateCampaignData,
                      onUpdateAtt: _ctx.updateAtt,
                      class: "p-grid p-col-10 p-m-auto",
                      campaignInfo: _ctx.campaign,
                      "short-preview": false,
                      hideInfo: { isCampaignCPM: _ctx.campaign && _ctx.campaign.paymentMethod === 'CPM' }
                    }, null, 8, ["onUpdateCampaign", "onUpdateAtt", "campaignInfo", "hideInfo"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeIndex"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}